<sis-icon icon="sorter" [iconClass]="(column===current && order==='desc') ? 'flip-180' : null" [color]="!(column===current) ? 'default' : 'primary-dark'"></sis-icon>
